export default "__VITE_ASSET__BMDYU8z7__"